/* eslint-disable no-unused-expressions */
import React from 'react';
import './MyControlActive.css';
import {store} from '../../Redux/Store/Store';
import * as actions from '../../Redux/Actions/Controls';
import * as actionsProg from '../../Redux/Actions/Programs';
import {connect} from 'react-redux';
import * as PropertyBucket from '../../Properties/Properties';
import * as ControlFunctions from '.././ManageControlCommons/ManageControlCommons';
import 'react-datepicker/dist/react-datepicker.css';
import {Link} from 'react-router-dom';
import {Waiter} from '.././WaitingSign/Waiting';
import PopUp from '.././PopUp/PopUp';
import * as httpService from '../HttpService/HttpService';
import {Documents} from '../documents';
import {endsControlWithAfterControlNote, getPostControlDocuments} from '../documents/helpers';
import {ControlDto} from '../Dtos/ControlDto';
import {ObjectionStatementDto} from '../Dtos/ObjectionStatementDto';
import {getTablePageBaseOnControlNumber, getTablePageBaseOnPageNumber} from '../../Helpers/utils';
import {UploadDocumentsPopup} from '../UploadDocumentsPopup/UploadDocumentsPopup';
import {RemarksDetail} from '../Remarks/RemarksDetail';
import SelectCustom from '../SelectCustom/SelectCustom';
import DatePickerCustom from '../DatePickerCustom/DatePickerCustom';
import {customDateConversion} from "../DatePickerCustom/DateHelper";
import TableCustomLazyLoading from "../TableCustom/TableCustomLazyLoading";
import {getControlDetails} from "../../Properties/Properties";
import {cloneDeep} from "lodash";

export const GET_CONTROL_DATA_REQUESTED = 'GET_CONTROL_DATA_REQUESTED';
export const GET_CONTROL_DATA_DONE = 'GET_CONTROL_DATA_DONE';
export const GET_CONTROL_DATA_FAILED = 'GET_CONTROL_DATA_FAILED';

class MyControlActive extends React.Component {

	columnsDefault = [
		{title: 'Numer kontroli', field: 'number', cellStyle: { width: '305px', minWidth: '305px' }},
		{title: 'Data rozpoczęcia kontroli', field: 'dateStart', width: 80},//term
		{title: 'Beneficjent', field: 'beneficiary', minWidth: 120, className: 'beneficiary'},
		{title: 'Rodzaj kontroli', field: 'controlKind', width: 110},//kind
		{title: 'Typ kontroli', field: 'controlType', width: 120},//type
		{title: 'Tryb kontroli', field: 'controlMode', width: 90},//mode
		{title: 'Zespół kontrolujący', field: 'controllersDescription', minWidth: 130},
		{title: 'Data otrzymania informacji pokontrolnej przez podmiot kontrolowany', field: 'postControlInfoReceivedDate', width: 90},//postControlInfoIssueDate
		{title: 'Data otrzymania zastrzeżeń', field: 'objectionsReceivedDate', width: 90},//remarksIssueDate
		{title: 'Data wysłania informacji ostatecznej', field: 'finalInfoSentDate', width: 90}//postControlInfoFinalIssueDate
	];
	previousInputFocusId = null;

	constructor(props) {
		super(props);
		this.state = {
			isWaiting: false,
			showPopup: false,
			showDocumentsControl: null,
			issueDate: null,
			remarksIssueDate: null,
			finalIssueDate: null,
			objectionIssueDate: null,
			objectionExists: false,
			textRemarks: '',
			isUploadDocsWindowVisible: false,
			tablePageSize: 10,
			page: this.props.match.params.pageNumber ? parseInt(this.props.match.params.pageNumber) - 1 : 0,
			programSearch: "",
			quickSearch: "",
			filter: [],
			orderBy: "number",
			orderById: "",
			orderDirection: "asc",
			filterChangeOnField: null,
			columns: cloneDeep(this.columnsDefault),
			documentTitle: 'e-Kontrole | Moje kontrole w trakcie realizacji'
		};
		this.finalIssueDateRef = React.createRef();
		this.programmsMyControlActiveSelectRef = React.createRef();
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
		this.endControl = this.endControl.bind(this);
	}

	componentDidMount() {
		document.title = "e-Kontrole | Moje kontrole w trakcie realizacji";

		const {fetchControlData} = this.props;

		const newState = cloneDeep(this.state);
		if (this.props.controls.tableFilters.length && this.props.controls.tableName === document.title) {
			newState.columns = this.getDefaultFilters();
			newState.filter = this.props.controls.tableFilters;
		}
		if (this.props.controls.tableQuickSearch && this.props.controls.tableName === document.title) {
			newState.quickSearch = this.props.controls.tableQuickSearch;
		}
		if(this.props.match.params.pageNumber) {
			newState.page = parseInt(this.props.match.params.pageNumber) - 1;
		}
		if (store.getState().programs.selected) {
			newState.programSearch = [store.getState().programs.selected];
		}
		this.setState(newState);

		fetchControlData(newState.page, ControlFunctions.getFilterParam(newState.filter), [newState.orderBy, newState.orderDirection], newState.programSearch, newState.quickSearch, newState.tablePageSize, (e) => this.handleRedirect(e));
	}

	componentDidUpdate(prevState) {
		if (prevState.programs?.selected?.code !== this.props.programs?.selected?.code) {
			this.setValues([this.props.programs.selected]);
		}
	}

	handleRedirect = (e) => {
		if (e.totalPages <= this.state.page) {
			this.setState({
				page: 0
			});
			this.props.history.push(`/my_controls/active`)
			const {fetchControlData} = this.props;
			fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize);
		}
	}

	getDefaultFilters = () => {
		const columns = cloneDeep(this.columnsDefault);

		this.props.controls.tableFilters.forEach((filter, index) => {
			if (filter.filterValue) {
				columns[index].defaultFilter = filter.filterValue
			}
		});

		return columns;
	}

	handleClosePopUp() {
		this.setState({showPopup: false});
	}

	handleChangeFinalIssueDate = date => {
		this.setState({
			finalIssueDate: date !== null ? this.addHours(date, 2) : null
		});
	};

	addHours = (date, h) => {
		let newDate = new Date(date);
		newDate.setHours(newDate.getHours() + h);
		return newDate;
	};

	setValues = (values) => {
		this.props.history.push(`/my_controls/active`);
		this.setState({programSearch: values})
		this.setState({page: parseInt(0) })

		const {fetchControlData} = this.props;
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], values, this.state.quickSearch, this.state.tablePageSize);

	};

	showPopup = (title, notification, type, onClickEvent, size) => {
		this.setState({
			showPopup: true,
			popUp: {title: title, notification: notification, type: type, onClickEvent: onClickEvent, size: size}
		})

	};

	onDetailButtonClick = (row) => {
		this.props.history.push('/my_controls/control_detail/' + row.id);
	};

	onListEditButtonClick = (row) => {
		this.props.history.push('/my_controls/control_list/' + row.id);
	};

	onListPreviewButtonClick = (row) => {
		this.props.history.push('/my_controls/control_list_detail/' + row.id);
	};

	onPostInfoEditButtonClick = async(row) => {
		const { setFiltersData } = this.props;
		setFiltersData({ filter: this.state.filter, tableName: this.state.documentTitle });
		const { setQuickSearchData } = this.props;
		setQuickSearchData({quickSearch: this.state.quickSearch, tableName: this.state.documentTitle});
		if (row.postControlDocuments) {
			let documents = await getPostControlDocuments(row.id)
			this.showPopup('Dokumenty pokontrolne', this.displayInfosListTab(row, documents), 'notify', null, 3)
		} else {
			this.showPopup('Komunikat', PropertyBucket.getNoPostControlDocumentMessage(), 'notify')
		}
	};

	onRemarksButtonClick = async (row) => {
		let documents = await getPostControlDocuments(row.id)
		const postControlInfo = documents && documents[0]?.postControlInfo?.objection;
		const receivedByControlledEntityDate = documents && (documents[0]?.postControlInfo?.receivedByControlledEntityDate || documents[1]?.postControlInfo?.receivedByControlledEntityDate);
		if (receivedByControlledEntityDate) {
			this.setState({
				showWindow: true,
				record: row,
				documents: documents,
				showPopup: false,
				objectionIssueDate: postControlInfo?.issueDate,
				objectionExists: postControlInfo?.objectionExists,
				textRemarks: postControlInfo?.remarks
			});
			this.setState({showRemarksTab: true});
		}
		else {
			this.showPopup('Komunikat', PropertyBucket.getNoPostControlRemarksMessage(), 'notify')
		}
	};

	onEndControlButtonClick = async (row) => {

		let documents = await getPostControlDocuments(row.id)
		if (documents.length > 1 || (documents.length === 1 && (documents[0].postControlNote || documents[0].postControlInfo.remarksIssueDate === null))) {
			const validated = documents.length > 1 ? documents[1].postControlInfo.isValidated : documents[0].postControlInfo !== null ? documents[0].postControlInfo.isValidated : true;
			if (validated) {
				let action = documents[0].postControlInfo && documents[0].postControlInfo.remarksIssueDate !== null ? () => {
					this.showFinalIssueDateWindow(row, documents)
				} : () => {
					this.endControl(row, documents)
				};
				this.showPopup('Komunikat', PropertyBucket.endControlConfirmationMessage(row.number), 'confirm', action)
			} else {
				const isFinalInfoNotValid = documents.some(d => d.postControlInfo?.isFinalInfo && !d.postControlInfo?.isValidated);
				this.showPopup('Błąd',isFinalInfoNotValid ? PropertyBucket.postControlFinalInfoNotValidatedMessage() : PropertyBucket.postControlInfoNotValidatedMessage(), 'error')
			}

		} else {
			this.showPopup('Komunikat', PropertyBucket.getNoPostControlDocumentMessage(), 'notify')
		}

	};

	validateFinalIssueDates = (remarksIssueDate, finalIssueDate) => {
		return remarksIssueDate === null || remarksIssueDate <= finalIssueDate
	};

	remarksInfoSave = async (row, attachments) => {
		const { objectionExists, objectionIssueDate } = this.state;

		// this condition is simplified, because it is almost impossible to find
		// oneself in situation when objectionExists is false and values of date
		// and attachments are filled
		const documentValidated = !objectionExists || (!!objectionIssueDate &&
			attachments.filter(attachment => !attachment.toRemove).length > 0);

		if (documentValidated) {
			let documents = await getPostControlDocuments(row.id)
			this.isWaitingOnOff(true);
			let infoId = documents[0].postControlInfo.id;
			let url = PropertyBucket.getControlRemarksInfoSave(infoId);

			const objectionStatementDto = new ObjectionStatementDto();
			objectionStatementDto.objectionExists = objectionExists || false;
			objectionStatementDto.issueDate = objectionIssueDate ? customDateConversion(objectionIssueDate) : null;
			objectionStatementDto.remarks = this.state.textRemarks;
			objectionStatementDto.attachments = attachments;

			let callPromise = httpService.getServicePromise(url, 'POST', objectionStatementDto);

			const _this = this;
			callPromise.then(
				function () {
					_this.closeWindow();
					_this.props.fetchControlData(_this.state.page, ControlFunctions.getFilterParam(_this.state.filter), [_this.state.orderBy, _this.state.orderDirection], _this.state.programSearch, _this.state.quickSearch, _this.state.tablePageSize);
					_this.isWaitingOnOff(false);
					_this.showPopup('Komunikat', PropertyBucket.saveRemarksInfoMessage(), 'notify')
				},
				function (error) {
					_this.isWaitingOnOff(false);
					_this.showPopup('Błąd', error.message ? error.message : error, 'error')
				}
			)
		} else {
			this.showPopup('Błąd', PropertyBucket.remarksDocumentsValidationMessage(), 'error')
		}

	};

	endControl = (row, documents) => {
		let _this = this;
		let finalIssueDate = this.state.finalIssueDate;
		let validatedControlInfo = documents.length > 1 ? documents[1].postControlInfo.isValidated : documents[0].postControlInfo !== null ? documents[0].postControlInfo.isValidated : true;
		let controlNote = documents[0].postControlNote !== null ? documents[0].postControlNote.length : 0;
		let remarksDate = documents[0].postControlInfo && documents[0].postControlInfo.remarksIssueDate !== null ? this.addHours(new Date(documents[0].postControlInfo.remarksIssueDate), 2) : null;
		if (this.validateFinalIssueDates(remarksDate, finalIssueDate) && (validatedControlInfo || controlNote > 0)) {
			this.isWaitingOnOff(true);
			let controlId = row.id;
			let url = PropertyBucket.getChangeControlStatus(controlId);
			let controlDto = new ControlDto();
			controlDto.controlId = controlId;
			controlDto.controlStatus = 2;

			if (documents.length > 1 && documents[0].postControlInfo && documents[0].postControlInfo.remarksIssueDate !== null) {
				controlDto.dateEnd = finalIssueDate;
			}

			let callPromise = httpService.getServicePromise(url, 'PUT', controlDto);

			callPromise.then(
				function (message) {
					_this.props.fetchControlData();
					_this.closeWindow();
					_this.isWaitingOnOff(false);
					_this.showPopup('Komunikat', PropertyBucket.endControlMessage(), 'notify', () => {
						_this.props.history.push(`/my_controls/done?number=${row.number}`)
					})
				},
				function (error) {
					_this.isWaitingOnOff(false);
					_this.showPopup('Błąd', error.message ? error.message : error, 'error')
				}
			)
		} else {
			let validationMessage = '';
			this.validateFinalIssueDates(remarksDate, finalIssueDate) === false ? validationMessage += PropertyBucket.finalIssueDateValidationMessage() + '\n' : null;
			validatedControlInfo ? null : validationMessage += PropertyBucket.postControlInfoNotValidatedMessage();
			this.showPopup('Błąd', validationMessage, 'error')
		}

	};

	displayLink = (link, linkName) => {
		return <Link to={link} className='links'>{linkName}</Link>
	};

	displayButton = (action, name) => {
		return <button className='links' onClick={action}>{name}</button>
	};

	onCreateFinalPostControlInfoButtonClick = (row, documents) => {
		this.showPopup('Komunikat', PropertyBucket.preparePostControlFinalInfoMessage(), 'confirm', () => {
			this.createFinalPostControlInfo(row, documents)
		})
	};

	createFinalPostControlInfo = (row, documents) => {
		let _this = this;
		this.isWaitingOnOff(true);
		let controlId = row.id;
		let currentInfoId = documents[0].postControlInfo.id;
		let url = PropertyBucket.getCopyPostControlInfo(controlId, currentInfoId);

		let callPromise = httpService.getServicePromise(url, 'POST', null);

		callPromise.then(
			function (message) {
				let infoId = message.referenceId;
				_this.props.fetchControlData(_this.state.page, ControlFunctions.getFilterParam(_this.state.filter), [_this.state.orderBy, _this.state.orderDirection], _this.state.programSearch, _this.state.quickSearch, _this.state.tablePageSize);
				_this.isWaitingOnOff(false);
				_this.showPopup('Komunikat', PropertyBucket.createPostControlFinalInfoMessage(), 'confirm', () => {
					_this.redirectToInfo(infoId, controlId)
				})
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error.message ? error.message : error, 'error')
			}
		)
	};

	redirectToInfo = (infoId, controlId) => {
		this.props.history.push('/my_controls/' + controlId + '/post_control_info/' + infoId);
	};

	showActionsWindow = () => {
		const { record: row, showFinalDateTab, showRemarksTab } = this.state;
		return (
			<PopUp
				customContent
				scrolled={showRemarksTab}
				handleClosePopup={this.closeWindow}
				title={`${showRemarksTab ? 'Informacje' : ''}${showFinalDateTab ? 'Dodawanie daty rozpatrzenia zastrzeżeń' : ''}`}
			>
				<>
					{showRemarksTab &&
						<RemarksDetail
							number = {row.number}
							data = {this.state}
							documents={this.state.documents}
							postControl = {this.state.documents.find(x => !x.postControlInfo.isFinalInfo)}
							handleChangeRemarksIssueDate ={date => this.setState({objectionIssueDate: date})}
							handleChangeObjectionExists ={isObjection => this.setState({objectionExists : isObjection})}
							handleChangeTextRemarks = {textRemarks => this.setState({textRemarks : textRemarks})}
							remarksInfoSave = {attachments => this.remarksInfoSave(row, attachments)}
							closeWindow = {() => this.closeWindow()}
							onlyPreview={this.state.documents.length === 2 ? true : null}
						/>
					}
					{showFinalDateTab && this.displayFinalDateTab(row)}
				</>
			</PopUp>
		)
	};

	showFinalDateTab = () => {
		this.setState({
			showFinalDateTab: true
		});
	};

	showFinalIssueDateWindow = (row, documents) => {
		this.setState({
			showWindow: true,
			record: row,
			documents: documents,
			finalIssueDate: documents[1] && documents[1].postControlInfo.issueDate !== null ? this.addHours(new Date(documents[1].postControlInfo.issueDate), 2) : null,
			showPopup: false
		});
		this.showFinalDateTab();
	};

	closeWindow = () => {
		this.setState({
			showRemarksTab: false,
			showWindow: false,
			showFinalDateTab: false,
		});
	};

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	displayFinalDateTab = (row) => {
		let finalDateWindow;

		finalDateWindow = <div id='editWindowTab'><h5>Dotyczy kontroli {row.number}</h5>
			<div className='row'>
				<div className='col-md-6'>
					<DatePickerCustom
						datePickerId='datePickerInfo'
						label='Data rozpatrzenia zastrzeżeń'
						labelId='mt-3 font-weight-bold'
						className='data-picker'
						dateName='rozpatrzenia zastrzeżeń'
						selected={this.state.finalIssueDate}
						onChange={this.handleChangeFinalIssueDate}
						parentRef={this.finalIssueDateRef}
					/>
				</div>
			</div>
			<div className='btn_group mb-2'>
				<button className='btn save-btn' id='save_button' onClick={() => this.endControl(row)}>ZAPISZ</button>
				<button className='btn cancel-btn' onClick={() => this.closeWindow()}>ANULUJ</button>
			</div>
		</div>;
		return finalDateWindow;
	};

	displayInfosListTab = (row, documents) => {
		let infosListTab;
		let link = null;
		let linkOst = null;
		let buttonOst = null;
		let buttonRemarks = null;
		let buttonNote = null;
		let uploadDocs = null;
		console.log('list');

		const postControlDocumentsArray = documents;
		const docINF = postControlDocumentsArray.find(el => el.postControlInfo && !el.postControlInfo.isFinalInfo);
		const docOST = postControlDocumentsArray.find(el => el.postControlInfo?.isFinalInfo);

		if (docOST) {
			const infoId = docOST.postControlInfo.id;
			const linkOstPath = (docINF && docINF.postControlInfo.finalInfoSendDate ? '/my_controls/' + row.id + '/post_control_info_detail/' : '/my_controls/' + row.id + '/post_control_info/') + infoId;
			const linkOstName = row.number + '-OST';
			linkOst = this.displayLink(linkOstPath, linkOstName);
		}

		if (docINF) {
			const infoId = docINF.postControlInfo.id;
			const linkPath = ((docINF.postControlInfo.receivedByControlledEntityDate !== null) ? '/my_controls/' + row.id + '/post_control_info_detail/' : '/my_controls/' + row.id + '/post_control_info/') + infoId;
			const linkName = row.number + '-INF';
			link = this.displayLink(linkPath, linkName);

			uploadDocs = this.displayButton(() => {
				this.setState({
					record: row,
					documents: documents,
					isUploadDocsWindowVisible: true,
					showPopup: false,
					docType: 'INF'
				});
			}, 'PRZEKAZANIE DOKUMENTÓW');

			this.setState({
				remarksIssueDate: documents[0].postControlInfo.remarksIssueDate !== null ? new Date(documents[0].postControlInfo.remarksIssueDate) : null,
			});

			if (row.objectionsReceivedDate && !linkOst) {
				const actionOst = () => {
					this.onCreateFinalPostControlInfoButtonClick(row, documents)
				};
				const actionOstName = 'UTWÓRZ INFORMACJĘ OSTATECZNĄ';
				buttonOst = this.displayButton(actionOst, actionOstName);
			}
		}

		// -----

		if (documents[0].postControlNote) {
			let linkOstPath = '/my_controls/' + row.id + '/post_control_note/' + documents[0].postControlNote.id;
			let linkOstName = row.number + '-NOT';
			buttonNote = this.displayLink(linkOstPath, linkOstName);

			uploadDocs = this.displayButton(() => {
				this.setState({
					record: row,
					documents: documents,
					isUploadDocsWindowVisible: true,
					showPopup: false,
					docType: 'NOT'
				});
			}, 'PRZEKAZANIE DOKUMENTÓW');
		}


		infosListTab = <div id='editWindowTab'>
			<div>
				{link !== null ? link : null}
				{linkOst !== null ? linkOst : null}
				{buttonOst !== null ? buttonOst : null}
				{buttonRemarks !== null ? buttonRemarks : null}
				{buttonNote && buttonNote}
				{uploadDocs && uploadDocs}
			</div>
		</div>;
		return infosListTab;
	};

	prepareData = (data) => {
		return data.map(ControlFunctions.setupControlData);
	};

	focusOnFilterElement(_this) {
		const field = _this.state.filter.find(x => {
			if (this.state.filterChangeOnField) {
				return x.field === this.state.filterChangeOnField.field;
			} else {
				return x.filterValue !== undefined;
			}
		});

		if (field) {
			const elements = document.getElementsByClassName('MuiInput-inputTypeSearch');
			let findInputToFocus = false;

			for (let i = 0; i < elements.length; i++) {
				if (elements[i].value.length && elements[i].value === field.filterValue) {
					elements[i].focus();
					findInputToFocus = true;
					this.previousInputFocusId = i;
				}
			}

			if (!findInputToFocus && field.filterValue === '' && this.previousInputFocusId != null) {
				elements[this.previousInputFocusId].focus();
				this.previousInputFocusId = null;
			}
		}
	}

	handlePageChange(page, size) {
		this.setState({page: parseInt(page) })
		const {fetchControlData} = this.props;
		fetchControlData(page, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, size);
	}

	handleFilterChange(filter) {
		this.state.filter.forEach((filterField, id) => {
			if (filterField.filterValue !== filter[id].filterValue) {
				this.setState({ filterChangeOnField: filter[id] });
			}
		});
		this.props.history.push(`/my_controls/active`);
		this.setState({page: parseInt(0) })
		this.setState({filter: filter })
		const {fetchControlData, setFiltersData} = this.props;
		setFiltersData({ filter, tableName: this.state.documentTitle });
		fetchControlData(0, ControlFunctions.getFilterParam(filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize, () => this.focusOnFilterElement(this));
	}

	handleQuickSearchChange(search) {
		this.props.history.push(`/my_controls/active`);
		this.setState({quickSearch: search, page: 0});
		const {fetchControlData, setQuickSearchData} = this.props;
		const focusOnQuickSearchInput = () => {
			const element = document.querySelector('[placeholder="Szukaj"]');
			element.focus();
		};
		setQuickSearchData({quickSearch: this.state.quickSearch, tableName: this.state.documentTitle});
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, search, this.state.tablePageSize, focusOnQuickSearchInput);
	}

	handleOrderChange(column, order) {
		this.setState({page: parseInt(0) })
		this.props.history.push(`/my_controls/active`);
		const orderColumn = (this.state.columns[column] ? this.state.columns[column].field :'')
		this.setState({orderById: column})
		this.setState({orderBy: orderColumn})
		this.setState({orderDirection: order})
		const {fetchControlData} = this.props;
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [orderColumn, order], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize);
	}


	render() {
		const { roleDetails } = this.props.userData.user;
		let userRole = roleDetails.role;
		let loadedControlsData;
		loadedControlsData = this.state.loadedControlsData ? this.state.loadedControlsData : store.getState().controls.activeControls;
		let loadedProgsData;
		userRole === 'SA' ? loadedProgsData = store.getState().programs.programs : loadedProgsData = null;
		let table;
		let dropdown;
		let popUp;
		const controlNr = new URLSearchParams(this.props.history.location.search).get('number');
		this.state.showPopup ?
			(popUp = <PopUp type={this.state.popUp.type}
			                title={this.state.popUp.title}
			                notification={this.state.popUp.notification}
			                link={this.state.popUp.link}
			                onClickEvent={this.state.popUp.onClickEvent}
			                closePopUp={this.handleClosePopUp}
			                size={this.state.popUp.size}
			/>) : null;

		if (this.props.controls && this.props.controls.isActiveControlsLoading === false) {
			if (loadedControlsData.length >= 0) {
				let totalElements = 0
				if (loadedControlsData.length > 0) {
					totalElements = this.props.controls.filters.totalElements
				}
				this.prepareData(loadedControlsData);

				table = <TableCustomLazyLoading
					isActionsMultilines
					columns={this.state.columns}
					data={loadedControlsData}
					orderBy={this.state.orderById}
					orderDirection={this.state.orderDirection}
					count={totalElements}
					page={this.state.page}
					actions={[
						rowData => ({
							icon: 'library_books',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Szczegóły kontroli<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onDetailButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'find_in_page',
							iconProps: {style: {fontSize: '24px', color: '#0d47a1'}},
							disabled: rowData.additional,
							tooltip: <span>{rowData.postControlDocuments ? 'Podgląd listy' : 'Edycja listy'}<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								rowData.postControlDocuments ? this.onListPreviewButtonClick(rowData) : this.onListEditButtonClick(rowData)
							}
						}),
						rowData => ({
							icon: 'description',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Dokumenty pokontrolne<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onPostInfoEditButtonClick(rowData);
							},
						}),
						rowData => ({
							icon: 'message',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Zastrzeżenia<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onRemarksButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'folder',
							iconProps: {style: {fontSize: '24px', color: '#0d47a1'}},
							tooltip: <span>Pliki<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: async (event, rowData) => {
								let documents = await getPostControlDocuments(rowData.id)
								this.setState({endsControlWithAfterControlNote : endsControlWithAfterControlNote(documents)})
								this.setState({showDocumentsControl: rowData});
							}
						}),
						rowData => ({
							icon: 'event_available',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Zakończ kontrolę<span className='sr-only'> {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onEndControlButtonClick(rowData);
							}
						}),
					]}
					initialPage={controlNr ?
						getTablePageBaseOnControlNumber({
							controlNr,
							pageSize: 10, // initial PageSize currently is always 10
							list: loadedControlsData,
						}) :
						getTablePageBaseOnPageNumber(
							this.props.match.params.pageNumber,
							10, // initial PageSize currently is always 10
							loadedControlsData
					)}
					pageSize={this.state.tablePageSize}
					onChangePage={
						(page, size) => {
							this.props.history.push(`/my_controls/active/${parseInt(page) + 1}`)
							this.setState({page: parseInt(page)})
							this.setState({tablePageSize: parseInt(size)})
							this.handlePageChange(parseInt(page), parseInt(size))
						}
					}
					onFilterChange={(value) => {
						this.handleFilterChange(value)
					}}
					onQuickSearchChange={(value) => {
						this.handleQuickSearchChange(value)
					}}
					quickSearch={this.state.quickSearch}
					onOrderChange={(column, order) => {
						this.handleOrderChange(column, order)}
					}

				/>;
			}
		}

		if (userRole === 'SA' && loadedProgsData.length > 0) {
			dropdown = <div id='progs_select'>
				<SelectCustom
					labelField='code'
					placeholder='Programy'
					valueField='code'
					options={loadedProgsData}
					onChange={(values) => this.setValues(values)}
					searchFn={(selectProps) => {
						if (selectProps.state.search !== this.state.previousSearch) {
							const checkOptionCode = selectProps.props?.options?.find(spec => spec.code.toUpperCase().includes(selectProps.state?.search.toUpperCase()));
							if (!checkOptionCode) {
								selectProps.state['search'] = this.state.previousSearch;
								this.setState({});
							} else {
								this.setState({
									previousSearch: selectProps.state.search
								})
							}
						}
					}}
					multi
					isMulti
					id='programmsMyControlActiveSelectId'
					dropdownId='programmsMyControlActiveDropdownId'
					label='Programy'
					parentRef={this.programmsMyControlActiveSelectRef}
				/>
			</div>
		}

		const { showDocumentsControl: control } = this.state;
		return (
			<div id='control_search' className='active_controls'>
				{this.state.showWindow ? this.showActionsWindow() : null}
				{this.state.isUploadDocsWindowVisible && <UploadDocumentsPopup
																isPossibleSendData={true}
																isPossibleChangeDate={this.state.docType === 'INF' ? true : false}
																control={this.state.record}
																isFinalInfo={this.state.documents.find(x => x.postControlInfo?.isFinalInfo ? x.postControlInfo.isFinalInfo : false)}
																isValidated={this.state.documents.length === 2 ? this.state.documents.find(x => x.postControlInfo.isFinalInfo ? x.postControlInfo.isValidated : false) : (this.state.documents[0].postControlInfo ? this.state.documents[0].postControlInfo.isValidated : false) }
																isObjectionExists={this.state.documents && this.state.documents[0]?.postControlInfo?.objection?.objectionExists}
																showPopup={this.showPopup}
																handleLoading={this.isWaitingOnOff}
																handleReload={() => this.props.fetchControlData(this.state.page, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize)}
																handleClose={() => this.setState({
																	isUploadDocsWindowVisible: false,
																 })}
														 />}
				{popUp}
				{control !== null &&
					<Documents
						controlUuid={control.uuid}
						endsWithAfterControlNote={this.state.endsControlWithAfterControlNote}
						excludeFromCurrentControl
						inPopup
						projectUuid={control.project.metadata.uuid}
						withDocumentsList
						onCancel={() => this.setState({showDocumentsControl: null})}
					/>
				}
				<h2 className='mb-5'>Moje kontrole - W trakcie realizacji</h2>
				{userRole === 'SA' ? dropdown : null}
				<div id='controls_table'>
					{table}
				</div>
				<div id='waiter'><Waiter loading={this.state.isWaiting || this.props.controls.isActiveControlsLoading}/></div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch, ownParams) => {
	let url = PropertyBucket.getMyControlsActive()
	let page = 0;
	if(ownParams.match.params.pageNumber) {
		page = (ownParams.match.params.pageNumber-1)
	}
	return {
		fetchControlData: (pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, successCallback) => dispatch(actions.getControlData(url, page, pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, undefined, successCallback, 'active')),
		setFiltersData: (filters) => dispatch(actions.setFiltersData(filters)),
		setQuickSearchData: (quickSearch) => dispatch(actions.setQuickSearchData(quickSearch)),
	}
};
export const MyControlActiveProvider = connect(mapStateToProps, mapDispatchToProps)(MyControlActive);
